import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";
import SonyLogo from "../../assets/sonyLogo.png";
import './Header.css';
import { useContext } from "react";
import LoadingButton from '@mui/lab/LoadingButton';
import { signInWithRedirect, signOut, fetchAuthSession } from '@aws-amplify/auth'
import { AppContext } from "../../store/AppProvider";
import { SET_ROLES, SET_USER_NAME, UPDATE_LOGGED_IN_USER } from "../../store/reducer/LoggedInUserReducer";
import { useEffect } from "react";


export const Header = () => {

  const { name, setName, setRoles, setLoggedInUser, setActiveRole } = useContext(AppContext)
  const [anchorEl, setAnchorEl] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const open = Boolean(anchorEl);
  const handleLoginClick = () => {
    signInWithRedirect()
  }

  useEffect(() => {
    async function fetchUserSession() {
      const userSession = await fetchAuthSession();
      sessionStorage.setItem('userToken', JSON.stringify(userSession));
      sessionStorage.setItem('idToken', userSession?.tokens?.idToken);
    }
    fetchUserSession();
  }, []);

  const handleClick = (event) => {
    if (anchorEl) {
      handleClose(); // Close the menu if it's already open
    } else {
      setAnchorEl(event.currentTarget); // Open the menu
    }
  };
  const handleLogout = () => {
    signOut().then(() => {
      setLoggedInUser({ type: UPDATE_LOGGED_IN_USER, payload: { loggedIn: false } })
      setName({ type: SET_USER_NAME, payload: { displayName: null, family_name: null, given_name: null } })
      setRoles({ type: SET_ROLES, payload: { roles: [] } })
      setActiveRole('')
      sessionStorage.removeItem('expiryTime');
    })
  }
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <a href="#main" className="skip-to-main-content-link">skip to main content</a>
      <header className="header-test">
        <h1>
          <a href="/">
            <img src={SonyLogo} className="sonyLogo" alt="Sony Logo" />
          </a>
        </h1>
        <div className="navbar">
          <div>
            {name?.displayName ?
              <div
                style={{ color: '#fff', display: 'flex', alignItems: 'center', marginBottom: 5, fontSize: 16, fontWeight: 500, cursor: 'pointer' }}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                {name?.displayName}
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <Avatar sx={{ width: 35, height: 35 }}></Avatar>
                  </IconButton>
                </Tooltip>
                <Menu
                  id="account-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem onClick={() => { handleClose(true); setShowLogoutModal(true) }}>Logout</MenuItem>
                </Menu>
              </div> :
              <div>
                <LoadingButton
                  type="button"
                  onClick={handleLoginClick}
                  variant="contained"
                  sx={{ mt: 3, mb: 2, minWidth: "80%" }}
                >
                  Login
                </LoadingButton>
              </div>
            }


          </div>
        </div>
      </header>

      <>
        <Dialog
          open={showLogoutModal}
          onClose={() => setShowLogoutModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Logout"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want Logout?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={() => { setShowLogoutModal(false); handleLogout(); }}>Yes</Button>
            <Button variant='outlined' onClick={() => setShowLogoutModal(false)} autoFocus>
              no
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </>
  );
};